import { TranslateService } from 'ng2-translate';
/**
 * Created by Owner on 2016/8/13.
 */
import { AlertController } from 'ionic-angular';
import { Component, Input, Output, EventEmitter, ElementRef, AfterViewInit } from '@angular/core';
import { LotteryMath } from "../lotteryMath";
import { ToastController } from "ionic-angular";
import { AppDialog } from "../../appDialog";
import { LotteryPage } from "../../../pages/lottery/lottery";

const HASH_BASE_RATIO_START_LOXIEN = 'lx';
const HASH_BASE_RATIO_START_LOTRUOT = 'lt';

@Component({
    selector: 'lottery-num-fast',
    templateUrl: 'selectNumFast.html'
})
export class SelectNumFastComponent implements AfterViewInit {
    @Output() onTotal: EventEmitter<any> = new EventEmitter<any>();
    typeGame;
    descGuide: string;
    _selectAreaOption: any;
    arrNumItemFast: any;
    numArrVal: number;
    numRender: any;
    arrNumSelected = [];
    countNumSelected: number = 0;
    test: number = 0;
    valSequence: string;
    pageDome: HTMLElement;
    disableFlagBtn: boolean = false;
    defaultPosition: any = [];
    listNumberSelected = [];
    typeChonSo = 'chonsonhanh';
    @Input() methodID: any;

    @Input()
    set selectAreaOption(selectAreaOption: any) {
        this.descGuide = selectAreaOption.objCustom.methoddesc;
        this._selectAreaOption = selectAreaOption;
        this.arrNumItemFast = this.selectAreaOption.layoutfastslect;
        this.typeGame = this._selectAreaOption.mname;
        this.resetFirstNumFast();
    }
    get selectAreaOption() {
        return this._selectAreaOption;
    }

    constructor(private alertCtrl: AlertController, private el: ElementRef, private translate: TranslateService) {
        this.pageDome = el.nativeElement;
    }

    initView() {
        this.resetFirstNumFast();
    }

    resetFirstNumFast() {
        this.numArrVal = 0;
        this.countNumSelected = 0;
        this.arrNumSelected = [];
        this.listNumberSelected = [];
        this.disableFlagBtn = false;
        this.renderNumFast();
    }

    ionViewWillEnter() {
        this.listNumberSelected = [];
    }

    ngAfterViewInit() {

    }

    renderNumFast() {
       
        let getSequence = this.arrNumItemFast[this.numArrVal];
        let arrStrNumRender = [];
        if (getSequence) {
            let startNum = getSequence.start;
            let endNum = getSequence.end;

            if (this.arrNumSelected[startNum + '-' + endNum] === undefined) {
                this.arrNumSelected[startNum + '-' + endNum] = [];
            }

            this.valSequence = getSequence;

            for (let i = Number(startNum); i <= Number(endNum); i++) {
                let numStr: any = i;
                let objTemp = {
                    num: numStr,
                    status: 0
                };
                if (this.disableFlagBtn) {
                    objTemp.status = 2;
                }
                if (endNum.length === 3 && i < 10) {
                    numStr = '00' + i;
                } else if ((endNum.length === 2 && i < 10) || (endNum.length === 3 && i < 100)) {
                    numStr = '0' + i;
                }
                objTemp.num = numStr.toString();

                for (let item in this.arrNumSelected) {
                    if (item) {
                        if (this.arrNumSelected[item].length > 0) {
                            if (this.arrNumSelected[item].indexOf(objTemp.num) > -1) {
                                objTemp.status = 1;
                            }
                        }
                    }
                }
                arrStrNumRender.push(objTemp);
            }
        }
        this.numRender = arrStrNumRender;
    }

    selectedNumItem(el: any, elNumFast: string) {
      
        let getSequence = this.arrNumItemFast[this.numArrVal];
        let startNum = getSequence.start;
        let endNum = getSequence.end;
        let checkActive = el.currentTarget.classList.contains('active');
        let checkDisable = el.currentTarget.classList.contains('num__disable');
        let countNum = 0;

        if (checkDisable) return;

        if (checkActive) {
            el.currentTarget.classList.remove('active');
            let idxNum = this.arrNumSelected[startNum + '-' + endNum].indexOf(elNumFast);
            this.arrNumSelected[startNum + '-' + endNum].splice(idxNum, 1);
            // update new
            this.listNumberSelected = this.listNumberSelected.filter(item => item != elNumFast).filter(item => !item.includes('&'));
        } else {
            el.currentTarget.classList.add('active');
            this.arrNumSelected[startNum + '-' + endNum].push(elNumFast);
        }
        for (let item in this.arrNumSelected) {
            countNum += this.arrNumSelected[item].length;
        }
        // console.log('====================================');
        // console.log('click',this.listNumberSelected);
        // console.log('====================================');
        this.checkLxNum(countNum);
        this.setClassDisable();
        this.countNum();
        //LotteryPage.clickPlay();
        this.updateCountForRanges();
    }

    countNum() {
        let mname = this.selectAreaOption["mname"];
        let arrTempMer = this.listNumberSelected;
        if (mname.includes(HASH_BASE_RATIO_START_LOXIEN)) {
            let times = Number(mname.split(HASH_BASE_RATIO_START_LOXIEN)[1]);
            for (let item in this.arrNumSelected) {
                if (this.arrNumSelected[item].length < times) break;
                arrTempMer.push(this.arrNumSelected[item].join('&'));
            }

            arrTempMer =  arrTempMer.filter(item => item.includes('&'));
           
        } else if (mname.includes(HASH_BASE_RATIO_START_LOTRUOT)) {
            let times = Number(mname.split(HASH_BASE_RATIO_START_LOTRUOT)[1]);
            for (let item in this.arrNumSelected) {
                if (this.arrNumSelected[item].length < times) break;
                arrTempMer.push(this.arrNumSelected[item].join('&'));
            }

            arrTempMer =  arrTempMer.filter(item => item.includes('&'));
           
        } else {
            for (let item in this.arrNumSelected) {
                arrTempMer = arrTempMer.concat(this.arrNumSelected[item]);
            }
        }
       
        arrTempMer =  arrTempMer.filter((value, index, self) => self.indexOf(value) === index);
        
        this.countNumSelected = arrTempMer.length;
        // this.listNumberSelected = arrTempMer;
        this.onTotal.emit({
            total: arrTempMer.length,
            selectNo: arrTempMer,
            defaultPosition: this.defaultPosition,
            type: 'f-digital'
        });
    }

    checkLxNum(count: number) {
        if ((this.methodID === 3 || this.methodID === 16) && count === 2) { // lx2
            this.disableFlagBtn = true;
        } else if ((this.methodID === 4 || this.methodID === 17) && count === 3) { // lx3
            this.disableFlagBtn = true;
        } else if ((this.methodID === 5 || this.methodID === 18) && count === 4) { // lx4
            this.disableFlagBtn = true;
        } else if ((this.methodID === 27 || this.methodID === 28) && count === 4) { // lt4
            this.disableFlagBtn = true;
        } else if ((this.methodID === 29 || this.methodID === 30) && count === 8) { // lt8
            this.disableFlagBtn = true;
        } else if ((this.methodID === 31 || this.methodID === 32) && count === 10) { // lt10
            this.disableFlagBtn = true;
        } else {
            this.disableFlagBtn = false;
        }
    }

    setClassDisable() {
        let getElBtn = this.pageDome.querySelectorAll('.wrap__nums button:not(.active)');
        if (this.disableFlagBtn) {
            [].forEach.call(getElBtn, function (el) {
                el.classList.add("num__disable");
            });
        } else {
            [].forEach.call(getElBtn, function (el) {
                el.classList.remove("num__disable");
            });
        }
    }


    //update thêm

    setClassEnable() {
        let getElBtn = this.pageDome.querySelectorAll('.wrap__nums button:not(.active)');
        [].forEach.call(getElBtn, function (el) {
            el.classList.remove("num__disable");
        });
    }


    // new update
    // Hàm để cập nhật số lượng theo mỗi khoảng
    updateCountForRanges() {
        // Reset count trước khi tính lại
        this.arrNumItemFast.forEach(range => range.count = 0);
        
        this.listNumberSelected.forEach(num => {
            this.arrNumItemFast.forEach(range => {
                if (num >= range.start && num <= range.end) {
                    range.count++;
                }
            });
        });
    }

    showSequenceNum(e: any) {
        this.updateCountForRanges();

        let html = '<ul class="list__sequence">';
        for (let i = 0, len = this.arrNumItemFast.length; i < len; i++) {
            let classActive = '';
            let startNum = this.arrNumItemFast[i].start;
            let endNum = this.arrNumItemFast[i].end;
            let strCountNumShow = this.arrNumItemFast[i].count || ''; // Hiển thị count nếu có

            if (this.numArrVal === i) {
                classActive = 'active';
            }

            html += `<li class="sequenceItem clearfix ${classActive}">
                     <span class="valSelectedSeque">${startNum} - ${endNum}</span>
                     <div class="fr">
                       <span class="countSubNum">${strCountNumShow}</span>
                       <span class="checkedSequence"></span>
                     </div>
                   </li>`;
        }
        html += '</ul>';

        let alertSequence = this.alertCtrl.create({
            title: this.translate.instant('SELECT_NUMBER_SEQUENCE'),
            message: html,
            cssClass: 'alert__sequence',
            enableBackdropDismiss: false,
            buttons: [
                {
                    text: 'OK',
                    handler: () => {
                        this.renderNumFast();
                        setTimeout(() => {
                            this.selectMultipleNumbers();
                        }, 300)
                    }
                }
            ]
        });

        alertSequence.present().then(() => {
            let arrEl = document.querySelectorAll('.sequenceItem');
            for (let i = 0, len = arrEl.length; i < len; i++) {
                if (arrEl[i].querySelector('.countSubNum').textContent !== '') {
                    arrEl[i].querySelector('.countSubNum')["style"].display = 'inline-block';
                }
                arrEl[i].addEventListener('click', e => {
                    [].forEach.call(arrEl, function (el) {
                        el.classList.remove("active");
                    });
                    e.currentTarget["className"] += ' active';
                    this.numArrVal = i;
                });
            }
        }).catch(e => {
            console.log(e);
        });
    }

    handleNumbersGenerated(number) {
        this.listNumberSelected = number.split(/;|&/);
        // this.listNumberSelected = number.split(/;/);
        this.selectMultipleNumbers();

    }
    resetSelections() {

        // Clear active classes on all buttons  
        document.querySelectorAll('button.active').forEach((button) => {
            button.classList.remove('active');
        });

        // Reset the data array or object used to track selected numbers
        for (const key in this.arrNumSelected) {
            this.arrNumSelected[key] = []; // Clear each array for each range
        }
    }

    selectMultipleNumbers() {

        this.resetSelections();
        this.setClassEnable();
        this.checkLxNum(this.listNumberSelected.length);
        this.countNum();
        this.listNumberSelected.forEach(num => {
            // Find the button element that matches the num value in the view
            const element = Array.from(document.querySelectorAll('button'))
                .find((btn: Element) => btn.textContent?.trim() === num);

            if (element) {
                // Call selectedNumItem with each found element and its corresponding number
                this.selectedNumItem({ currentTarget: element }, num);
            } else {
                // console.warn(`Button for number ${num} not found`);
            }
        });

    }

}



// WEBPACK FOOTER //
// ./src/component/+lotteryMath/selectNumFast/selectNumFast.ts